export const APP_VERSION = "v1.1.0";
export const APP_YEAR = "2026";
